export default {"src":"/_next/static/media/pc_consultunt_img_02.4d1b118b.svg","height":140,"width":480};